import { render, staticRenderFns } from "./MergeTipDialog.vue?vue&type=template&id=bd6d207c"
import script from "./MergeTipDialog.vue?vue&type=script&lang=js"
export * from "./MergeTipDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports